export const EDIT_MODE_ACTION_TYPES = {
  RESET_CHANGES: 'RESET_CHANGES',
  CHANGE_ROW_DATA: 'CHANGE_ROW_DATA',
  SYNC_ROW_DATA: 'SYNC_ROW_DATA',
  CLEAR_ROWS_TO_ADD: 'CLEAR_ROWS_TO_ADD',
  RESTORE_ROWS_TO_ADD: 'RESTORE_ROWS_TO_ADD',
  ADD_ROW: 'ADD_ROW',
  UPDATE_GROUP: 'UPDATE_GROUP',
  UPDATE_ROW: 'UPDATE_ROW',
  DELETE_ROW: 'DELETE_ROW',
};

export const actionCreators = {
  addRow: (insertedRow, appendNewRows) => ({
    type: EDIT_MODE_ACTION_TYPES.ADD_ROW,
    payload: { insertedRow, appendNewRows },
  }),
  updateGroup: modifiedGroupRows => ({
    type: EDIT_MODE_ACTION_TYPES.UPDATE_GROUP,
    payload: modifiedGroupRows,
  }),
  updateRow: modifiedRow => ({ type: EDIT_MODE_ACTION_TYPES.UPDATE_ROW, payload: modifiedRow }),
  deleteRow: deletedRow => ({ type: EDIT_MODE_ACTION_TYPES.DELETE_ROW, payload: deletedRow }),
  changeRowData: clonedRowData => ({
    type: EDIT_MODE_ACTION_TYPES.CHANGE_ROW_DATA,
    payload: clonedRowData,
  }),
  syncRowData: clonedRowData => ({
    type: EDIT_MODE_ACTION_TYPES.SYNC_ROW_DATA,
    payload: clonedRowData,
  }),
  clearRowsToAdd: () => ({ type: EDIT_MODE_ACTION_TYPES.CLEAR_ROWS_TO_ADD }),
  restoreRowsToAdd: rowsToAdd => ({
    type: EDIT_MODE_ACTION_TYPES.RESTORE_ROWS_TO_ADD,
    payload: rowsToAdd,
  }),
  resetChanges: () => ({ type: EDIT_MODE_ACTION_TYPES.RESET_CHANGES }),
};
